import styled from "styled-components";
import { SmallButton, WrapperContainer } from "../../../../components";
import { RadialChartContainer } from "../../../../components/Charts/styled";

export const ChartWrapper = styled(WrapperContainer)`
  position: relative;

  ${RadialChartContainer} {
    flex-direction: column;
    gap: 24px;

    padding: 12px 0;
  }
`;

export const ChartControls = styled(WrapperContainer)`
  position: absolute;

  top: 0;
  right: 0;
`;

export const DownloadReportButton = styled(SmallButton)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;
